import Drawer from '../../Drawer';
import { formatPurchasePlanningNumber } from '../../../lib/purchasePlanningHelpers';

export function ContainerOptimizationInspectDrawer({
  open,
  onClose,
  selectedGroup,
  groupRows,
  marginFromSidebar,
}) {
  return (
    <Drawer
      isOpen={open}
      onClose={onClose}
      title={
        selectedGroup
          ? `${selectedGroup.containerGroup} · Container pool`
          : 'Container pool drill-through'
      }
      showActionButtons={false}
      width="520px"
      marginFromSidebar={marginFromSidebar}
      bodyClassName="!p-0"
    >
      {selectedGroup ? (
        <div className="flex h-full flex-col overflow-hidden">
          <p className="border-b border-gray-200 px-5 py-3 text-sm text-gray-500">
            {selectedGroup.supplier} · {selectedGroup.months.join(', ') || 'Unscheduled'}
          </p>

          <div className="flex-1 space-y-4 overflow-auto px-5 py-4">
            <section className="rounded-lg border border-gray-200 bg-white p-4">
              <h3 className="text-sm font-semibold text-gray-900">Group logic</h3>
              <div className="mt-3 space-y-2 text-sm text-gray-600">
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                  <span>Group base buy</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.groupBaseBuy)}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-white px-3 py-2">
                  <span>Containers × container qty</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.containers)} ×{' '}
                    {formatPurchasePlanningNumber(selectedGroup.containerQty)}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-white px-3 py-2">
                  <span>Total MOQ buy</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.totalMoqBuy)}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-white px-3 py-2">
                  <span>Fill gap</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.fillGap)}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-white px-3 py-2">
                  <span>Fill units</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.fillUnits)}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-3 rounded-md border border-gray-200 bg-slate-50 px-3 py-2">
                  <span>Adjusted final buy</span>
                  <span className="font-semibold text-gray-900">
                    {formatPurchasePlanningNumber(selectedGroup.adjustedGroupUnits)}
                  </span>
                </div>
              </div>
              <p className="mt-3 text-sm leading-6 text-gray-600">
                The fill quantity above is not new demand. It is procurement-optimization inventory
                used to improve freight efficiency and supplier execution quality inside the governed
                container pool.
              </p>
            </section>

            {groupRows.length > 0 ? (
              <section className="rounded-lg border border-gray-200 bg-white p-4">
                <h3 className="text-sm font-semibold text-gray-900">SKU allocation inside the pool</h3>
                <div className="mt-3 space-y-2">
                  {groupRows.map(row => (
                    <div
                      key={row.id}
                      className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 px-3 py-3 text-sm"
                    >
                      <div className="min-w-0 pr-3">
                        <p className="truncate font-medium text-gray-900">{row.supplySku}</p>
                        <p className="truncate text-xs text-gray-500">{row.productName}</p>
                      </div>
                      <div className="text-right text-xs text-gray-600">
                        <p>
                          Remaining demand {formatPurchasePlanningNumber(row.remainingAnnualDemand ?? row.otbUnits)} · MOQ buy{' '}
                          {formatPurchasePlanningNumber(row.moqBuyUnits)}
                        </p>
                        <p>
                          Base buy {formatPurchasePlanningNumber(row.baseBuyUnits)} · Fill{' '}
                          {formatPurchasePlanningNumber(row.fillUnits ?? row.fillAllocatedUnits)}
                        </p>
                        <p className="font-medium text-gray-900">
                          Adjusted {formatPurchasePlanningNumber(row.adjustedRoundedUnits)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            ) : null}
          </div>
        </div>
      ) : null}
    </Drawer>
  );
}
